var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.714355 11.0001L11.0001 0.714355L21.2858 11.0001",
    stroke: "#BDC2E3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.71436V17.8572C3 18.1603 3.12041 18.451 3.33474 18.6653C3.54906 18.8797 3.83975 19.0001 4.14286 19.0001H7.57143C7.87453 19.0001 8.16522 18.8797 8.37955 18.6653C8.59388 18.451 8.71429 18.1603 8.71429 17.8572V13.2858C8.71429 12.9827 8.83469 12.692 9.04902 12.4777C9.26335 12.2633 9.55404 12.1429 9.85714 12.1429H12.1429C12.446 12.1429 12.7367 12.2633 12.951 12.4777C13.1653 12.692 13.2857 12.9827 13.2857 13.2858V17.8572C13.2857 18.1603 13.4061 18.451 13.6205 18.6653C13.8348 18.8797 14.1255 19.0001 14.4286 19.0001H17.8571C18.1602 19.0001 18.4509 18.8797 18.6653 18.6653C18.8796 18.451 19 18.1603 19 17.8572V8.71436",
    stroke: "#BDC2E3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIc);
export default __webpack_public_path__ + "static/media/home-ic.25d4a406e3b020b6a0fad6f7a5dff2c0.svg";
export { ForwardRef as ReactComponent };